import type { Dispatch, MutableRefObject, SetStateAction } from 'react';
import React from 'react';
import { loadModulePromise } from 'src/components/YandexMap/mapLoader';
import { loadReactComponent } from 'src/components/YandexMap/loaders/componentLoaders';
import ZoomControlButtons from 'src/components/YandexMap/components/Controls/components/ZoomControlButtons';
import FullscreenControlButton from 'src/components/YandexMap/components/Controls/components/FullscreenControlButton';

const YMapControls = loadReactComponent('YMapControls', loadModulePromise);

type ControlProps = {
  isExpanded: boolean;
  isMobile: boolean;
  toggleHandler: () => void;
  readonlyZoom: MutableRefObject<number>;
  setZoom: Dispatch<SetStateAction<number>>;
};

const Controls = (props: ControlProps) => {
  const { isExpanded, toggleHandler, isMobile, readonlyZoom, setZoom } = props;
  return (
    <>
      <YMapControls position={isMobile ? 'left' : 'top left'}>
        <ZoomControlButtons readonlyZoom={readonlyZoom} setZoom={setZoom} />
      </YMapControls>
      {!isMobile && (
        <YMapControls position="top right">
          <FullscreenControlButton
            isExpanded={isExpanded}
            toggleHandler={toggleHandler}
          />
        </YMapControls>
      )}
    </>
  );
};

export default Controls;
